import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	list: {
		margin: "0 auto"
	},
	listItem: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderRadius: "6px",
		boxShadow: "3px 3px 16px rgba(0, 0, 0, 0.06)"
	},
	listItemText: {
		fontWeight: "normal"
	},
	nextIcon: {
		color: colors.gray[500],
		minWidth: "0px"
	},
	nextIconDisabled: {
		opacity: "0.4"
	},
	emailValidationButton: {
		padding: "8px 16px 8px 16px",
		radius: 8,
		height: 48,
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[500]),
		fontSize: 14,
		fontWeight: 400,
		lineHeight: 20,
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.yellow[600]),
			cursor: "pointer"
		}
	},
	buttonText: {
		color: colors.gray[0]
	}
})

export default useStyles
